import React, { useState } from "react";


const UploadImaProd = () => {

    const [formData, setFormData] = useState({
        customer_id: "",
        product_id: "",
        category: "",
        product_name: "",
        description: "",
        price: "",
        image: {url:"", color:"", size:""}
    
    
      });
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setFormData({ ...formData, image: reader.result });
          };
          reader.readAsDataURL(file);
          console.log(formData);
        }
      };

    return (
        <div className="image-upload-container">
            {/* Display the image preview or the default image */}
            <div className="image-preview-container">
            {formData.image ? (
                <img src={formData.image} alt="Vista previa" className="image-preview" />
            ) : (
                <div className="image-placeholder">
                <span>Espacio para subir imagen</span>
                </div>
            )}
            </div>

            {/* File input */}
            <label>
            <span>Subir Imagen:</span>
            <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
            />
            </label>
        </div>
    )

};

export default UploadImaProd;